import * as React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { brandColors, device } from '../../styles/variables';
import burger from '../../assets/images/burger.png';
import { actionOverlay } from '../../store/Overlay';

const Wrapper = styled.div`
  width: 100%;
`;

const ClickBox = styled.div`
  ${({ overlay }) => `
    display: ${overlay.opened && overlay.overlayType === 'menu' ? 'none' : 'block'}
  `};
  position: fixed;
  top: 0;
  z-index: 9999;
  background-color: ${brandColors.orange};
  cursor: pointer;
  width: 40px;
  height: 100px;
  right: 40px;
  @media ${device.tablet} {
    right: 60px;
    width: 80px;
    height: 160px;
  }

  img {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    margin-top: 21.6px;
    height: 17px;
    max-width: 36px;
    @media ${device.tablet} {
      margin-top: 48.6px;
      height: 25px;
    }
  }
`;

class MenuOpener extends React.PureComponent {
  triggerOverlay() {
    const { openOverlay } = this.props;
    // separated out into another function to allow to call the animation of the overlay!
    const state = {
      opened: true,
      overlayType: 'menu'
    };
    openOverlay(state);
  }

  render() {
    const { overlay, className } = this.props;

    return (
      <Wrapper className={className}>
        <ClickBox onClick={() => this.triggerOverlay()} overlay={overlay}>
          <img src={burger} alt="Open menu" />
        </ClickBox>
      </Wrapper>
    );
  }
}

MenuOpener.defaultProps = {
  overlay: {},
  className: ''
};

MenuOpener.propTypes = {
  overlay: PropTypes.object,
  openOverlay: PropTypes.func.isRequired,
  className: PropTypes.string
};

const mapStateToProps = state => ({
  overlay: state.overlay
});

const mapDispatchToProps = dispatch => ({
  openOverlay(overlayState) {
    dispatch(actionOverlay(overlayState));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MenuOpener);



// WEBPACK FOOTER //
// ./src/components/MenuOpener/index.jsx